import styled from "styled-components";
import {
  SPIN_BONUS_IMG,
  BONUS_IMG,
  RefreshOutlined,
  IMG_WALLET_BG,
} from "@assets";
import {
  REJECTED_SK,
  REQUESTED_SK,
} from '@constants';

export const RootContainer = styled.div`
position: relative;
height: 100vh;
overflow: hidden;
`;

export const Background = styled.img.attrs({
  alt: 'bg',
  src: IMG_WALLET_BG,
})`
position: absolute;
top: 0;
width: 100%;
height: 100%;
object-fit: cover;
border-radius: 8px;

@media screen and (max-width: 400px) {
object-fit: contain;
}
`;

export const RefreshIcon = styled(RefreshOutlined)`
  font-size: 24px;
  color: #fff;
`;

export const TopContainer = styled.div`
position: relative;
padding: 14px 16px;
`;

export const TopBox = styled.div`
padding: 16px;
border-radius: 8px;
background: linear-gradient(180deg, #AA5E1B 0%, #FFD648 67.98%);
`;

export const TopWrapper = styled.div`
width: 100%;
padding: 16px 0;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
gap: 4px;
position: relative;
background-color: #F4F4F4;
border-radius: 8px;

svg {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;

export const TopTitle = styled.div`
font-size: 15px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #2A2A2A;
`;

export const BalanceText = styled.div`
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 1.5;

background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
`;

export const LabelsContainer = styled.div`
padding-top: 10px;
display: flex;
align-items: center;
justify-content: center;
`;

export const LightText = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 1.5;
color: #2A2A2A;
`;

export const LightTextLabel = styled(LightText)`
color: #2A2A2A;
font-weight: 400;
`;

export const LabelWrapper = styled.div`
flex: 1;
text-align: center;

:first-child {
  border-right: 1px solid #814816;
}
`;

export const ActionLabel = styled.div`
font-size: 13px;
font-style: normal;
font-weight: 700;
line-height: 1.5;

@media screen and (max-width: 326px) {
  font-size: 12px;
}
`;

export const ActionButton = styled.div`
flex: 1;
padding: 10px 0;
display: flex;
justify-content: center;
align-items: center;
gap: 4px;

background: ${props => props.transparent === 1 ? 'transparent' : props.theme.buttonColor};
border: ${props => props.transparent === 1 ? '1px solid #D66700' : 'none'};
border-radius: 8px;
cursor: pointer;

${ActionLabel} {
  color: ${props => props.transparent === 1 ? '#D66700' : '#2A2A2A'};
}
`;

export const ActionsWrapper = styled.div`
width: 100%;
margin-top: 16px;
display: flex;
gap: 16px;
align-items: center;
justify-content: center;
`;

export const SeeAllText = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 1.5;
color: #814816;
cursor: pointer;
`;

export const ListTitle = styled.div`
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 1.5;
color: #2A2A2A;
`;

export const ListContainer = styled.div`
height: calc(100vh - 443px);
overflow-y: auto;
padding: 0 16px;

.loader {
    height: calc(100vh - 443px);
    display: flex;
    align-items: center;
    justify-content: center;
}

.empty-box {
    height: calc(100vh - 443px);
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: center;
    justify-content: center;

    svg {
        font-size: 24px;
        color: #808080;
    }
}

/* Hide scrollbar for Chrome, Safari and Opera */
::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const ListItem = styled.div`
  padding: 12px;
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background-color: #fff;
  border-radius: 4px;

  @media screen and (max-width: 375px) {
      padding: 16px 8px;
      gap: 6px;
    }

  @media screen and (max-width: 305px) {
    padding: 12px 6px;
    }
`;

export const DataWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 4px;
`

export const ItemImage = styled.img.attrs({
  alt: 'img'
})`
width: 24px;
height: 24px;
border-radius: 4px;
object-fit: cover;
`;

export const InfoWrapper = styled.div`
flex: 1;
display: flex;
width: 100%;

> :nth-child(1) {
  flex: 1;
}
`;

export const Wrapper = styled.div`
gap: 3px;
display: flex;
flex-direction: row;
align-items: center;
justify-content: flex-start;
`;

export const ItemText = styled.div`
flex: 1;
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 1.5;
text-transform: capitalize;
color: #2A2A2A;

  @media screen and (max-width: 400px) {
    font-size: 13px;
  }

  @media screen and (max-width: 300px) {
    font-size: 12px;
  }
`;

export const DateText = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #5C5C5C;

@media screen and (max-width: 425px) {
    font-size: 12px;
  }

@media screen and (max-width: 375px) {
    font-size: 11px;
  }

@media screen and (max-width: 305px) {
    font-size: 10px;
  }
`;

export const AmountText = styled.div`
white-space: nowrap;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: normal;
color: #2A2A2A;

  @media screen and (max-width: 400px) {
    font-size: 16px;
  }

  @media screen and (max-width: 300px) {
    font-size: 12px;
  }
`;

export const StatusText = styled.div`
display: flex;
padding: 2px 12px;
flex-direction: column;
justify-content: center;
align-items: center;
border-radius: 100px;

white-space: nowrap;
font-size: 11px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
text-transform: capitalize;
color: ${(props) =>
    props.status === REQUESTED_SK
      ? "#FBF5E6"
      : props.status === REJECTED_SK
        ? "#ffffff"
        : "#E8FBEC"};
background-color: ${(props) =>
    props.status === REQUESTED_SK
      ? "#D69A00"
      : props.status === REJECTED_SK
        ? "#BF3837"
        : "#12A132"};
border-radius: 27px;
display: flex;
align-items: center;
justify-content: center;

  @media screen and (max-width: 300px) {
    font-size: 11px;
  }
`;

export const BonusStatusText = styled(StatusText)`
text-transform: none;
width: auto;
color: ${(props) => props.status === 'Used' ? "#FBF5E6" : "#E8FBEC"};
background-color: ${(props) => props.status === 'Used' ? "#9F9F9F" : "#12A132"};
`;

export const ImageWrapper = styled.div`
object-fit: cover;
display: flex;
align-items: center;
justify-content: center;

svg {
  width: 30px;
  height: 30px;
  margin-left: -3px;
}
`;

const Image = styled.img.attrs({
  alt: "img",
})`
width: 100%;
object-fit: contain;
align-self: center;
`;

export const SpinImage = styled(Image).attrs({
  src: SPIN_BONUS_IMG,
})``;

export const BonusImage = styled(Image).attrs({
  src: BONUS_IMG,
})``;

export const ExpiredLabel = styled.span`
white-space: nowrap;
color: #BF3837;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 1.5;

  @media screen and (max-width: 390px) {
    font-size: 13px;
  }

@media screen and (max-width: 425px) {
    font-size: 12px;
  }

@media screen and (max-width: 375px) {
    font-size: 11px;
  }

@media screen and (max-width: 305px) {
    font-size: 10px;
  }
`;

export const CommentText = styled(ExpiredLabel)`
white-space: normal;
word-break: break-all;
`;

export const ExpiredText = styled(ExpiredLabel)`
color: #5C5C5C;
`;

export const ListRootContainer = styled.div`
height: calc(100vh - 340px);
position: relative;
`;

export const ListTitleWrapper = styled.div`
display: flex;
justify-content: space-between;
padding: 0 16px 6px 16px;

@media screen and (max-width: 375px) {
  padding: 0 12px 6px 12px;
}

  @media screen and (max-width: 305px) {
    padding: 0 8px 6px 8px;
    }
`;

export const EmptyBox = styled.div`
	width: 100%;
	height: calc(100vh - 443px);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

export const BoldText = styled.div`
padding-top: 16px;
font-size: 16px;
font-weight: 700;
color: #2A2A2A;
line-height: 1.5;
`;

export const NoResultText = styled.div`
	padding-top: 8px;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	color: #5D5189;
`;